const carousels = async function () {
    const relatedCarousel = [...document.querySelectorAll(".related-swiper")];
    const homeStoriesCarousel = [...document.querySelectorAll(".swiper-home-stories")];
    const quizCarousel = [...document.querySelectorAll(".swiper-quiz")];

    if (relatedCarousel || homeStoriesCarousel || quizCarousel) {
        const Swiper = await (await import("swiper/bundle")).default;

        if (relatedCarousel) {
            relatedCarousel.forEach(section => {
                const carousel = new Swiper(section.querySelector(".swiper"), {
                    loop: true,
                    speed: 600,
                    slidesPerView: 1.3,
                    spaceBetween: 21,
                    autoplay: {
                        delay: 3000,
                    },
                    breakpoints: {
                        500: {
                            slidesPerView: 1.5,
                            spaceBetween: 21
                        },
                        768: {
                            slidesPerView: 2.2,
                            spaceBetween: 21,
                        },

                    },
                })
            })
        }
        
        if ( homeStoriesCarousel ) {
            homeStoriesCarousel.forEach(section => {
                const carousel = new Swiper(section, {
                    loop: true,
                    speed: 750,
                    slidesPerView: 1,
                    spaceBetween: 0,
                    autoplay: {
                        delay: 10000,
                    },
                    // Navigation arrows
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                })
            })
        }
        
        if ( quizCarousel ) {
            quizCarousel.forEach(section => {
                const carousel = new Swiper(section, {
                    loop: false,
                    autoplay: false,
                    speed: 750,
                    slidesPerView: 1,
                    spaceBetween: 0,
                    autoHeight: true,
                    simulateTouch: false,
                    allowTouchMove: false,
                    watchSlidesProgress: true,
                    shortSwipes: false,
                })

                carousel.on('transitionEnd', function() {
                    if ( carousel.realIndex === carousel.slides.length -1 ) {
                        document.querySelector('.take-the-quiz').classList.add('show-story');
                    }
                });
                
                const quiz = section.querySelectorAll(".quiz-question");
                const nextQuestion = section.querySelectorAll(".btn--quiz");
                
                nextQuestion.forEach(question => {
                    question.addEventListener('click', (e) => {
                        e.preventDefault();
                        
                        if ( question.classList.contains('is-active') ) {
                            carousel.slideNext();
                        }
                    });
                })
    
                quiz.forEach(question => {
                    const radios = question.querySelectorAll('input[type="radio"]');
                    
                    radios.forEach(radio => {
                        radio.addEventListener('change', () => {
                            question.querySelector('.btn--quiz').classList.add('is-active');
                        })
                    })
                })
            })
            
        }
    }
}

export const init = carousels;